"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var FormManager_1 = __importDefault(require("./FormManager"));
function useForm(initialState) {
    if (initialState === void 0) { initialState = {}; }
    var emptyValue = function () { return isArray_1.default(initialState.values) ? [] : {}; };
    var defaultState = {
        values: cloneDeep_1.default(initialState.values) || emptyValue(),
        initialValues: cloneDeep_1.default(initialState.initialValues || initialState.values) || emptyValue(),
        formattedValues: initialState.formattedValues || emptyValue(),
        touched: initialState.touched || emptyValue(),
        valid: initialState.valid || emptyValue()
    };
    var _a = react_1.useState(defaultState), state = _a[0], setState = _a[1];
    return new FormManager_1.default(state, setState);
}
exports.default = useForm;
